import { render } from "./import-employee.vue?vue&type=template&id=8c94bf1a&scoped=true"
import script from "./import-employee.vue?vue&type=script&lang=js"
export * from "./import-employee.vue?vue&type=script&lang=js"

import "./import-employee.vue?vue&type=style&index=0&id=8c94bf1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c94bf1a"]])

export default __exports__